const Skeleton = ({ width = '100%', height = '1rem', className = '' }) => (
    <div
        className={`bg-gray-200 rounded animate-pulse ${className}`}
        style={{ width, height }}
    />
);

export default Skeleton;
